import Vue from 'vue'
import store from './store'
import i18n, {initializeLang} from './plugins/i18n'
import {setupGTM} from './plugins/gtm'
import VueCookies from 'vue-cookies'
import SearchBar from '@/components/SearchBar'
import SearchResults from '@/components/SearchResults'
import SearchResultsPWA from '@/components/SearchResultsPWA'
import VueLoading from './plugins/VueLoading'
import SearchToggle from '@/components/Nav/SearchToggle'
import QuickViews from '@/components/QuickViews'
import TourGuide from '@/components/TourGuide'
import PwaNavLeft from '@/components/Nav/PwaNav/PwaNavLeft';
import PwaNavRight from "@/components/Nav/PwaNav/PwaNavRight";
import PortalVue from 'portal-vue'
import vClickOutside from 'v-click-outside'
import VueToastr from "./plugins/VueToastr";
import Fragment from "vue-fragment";
import NineDots from '@/components/NineDots';
import AIChat from '@/components/AIChat';
import AICompare from '@/components/AICompare';
import AIFaq from '@/components/AIFaq';
import VueShowdown from 'vue-showdown';
import loadMathJax from "@/directives/mathjaxDirective";


Vue.config.productionTip = false
//Vue.config.devtools = true
Vue.use(VueCookies)
Vue.use(PortalVue)
Vue.use(vClickOutside)
Vue.use(Fragment.Plugin);
Vue.use(VueShowdown);
setupGTM();
initializeLang();
loadMathJax();

const componentOptions = {
    store,
    i18n,
    VueLoading,
    VueToastr
};

const mountComponent = (selector, component) => Array.from(document.querySelectorAll(selector)).map(element => {
    const attrs = {};
    Array.from(element.attributes).forEach(attribute => {
        if (attribute.name !== 'class' && attribute.name !== 'style') {
            attrs[attribute.name] = attribute.value;
        }
    });

    return new Vue({
        ...componentOptions,
        render: h => h(component, {
            attrs,
            class: element.getAttribute('class') || undefined,
            style: element.getAttribute('style') || undefined
        })
    }).$mount(element);
});

const mountedApps = [
    ...mountComponent('search-bar', SearchBar),
    ...mountComponent('search-results', SearchResults),
    ...mountComponent('search-toggle', SearchToggle),
    ...mountComponent('quick-views', QuickViews),
    ...mountComponent('search-results-pwa', SearchResultsPWA),
    ...mountComponent('pwa-nav-left', PwaNavLeft),
    ...mountComponent('pwa-nav-right', PwaNavRight),
    ...mountComponent('tour-guide', TourGuide),
    ...mountComponent('nine-dots', NineDots),
    ...mountComponent('ai-chat', AIChat),
    ...mountComponent('ai-compare', AICompare),
    ...mountComponent('ai-faq', AIFaq)
];

window.webShopVueApp = mountedApps[0] || null;
